import { createFileRoute } from "@tanstack/react-router";
import { FilesPage } from "~/pages/FilesPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/files")({
  component: RouteComponent,
});

function RouteComponent() {
  return <FilesPage />;
}
